<form #refMeasurementsForm="ngForm" class="ref-measurements-form p-sm-1">

    <div id="measurement-photos" *ngIf="!hidePhotos && showTitlebar && _scoutPoint" class="ref-measurements-titlebar px-1"
        [ngStyle]="{'background-color': _scoutPoint.color}">
        <div class="d-flex flex-row justify-content-between">
            <div>
                <button class="btn btn-scroll-to" (click)="scrollTo('scout-point-editor')"><i class="fa fa-step-backward"></i></button>
            </div>
            <div class="flex-grow-1">Reference Measurements {{_scoutPoint.name}}</div>
            <div>
                <button class="btn btn-scroll-to" (click)="scrollTo('wide-angle-photos')"><i class="fa fa-step-forward"></i></button>
                <button class="btn btn-scroll-to" (click)="scrollTo('additional-photos')"><i class="fa fa-fast-forward" title="Additional Photos"></i></button>                    
            </div>
        </div>                     
    </div>

    <div *ngIf="_scoutPoint" class=" m-0 container-fluid">
        <div class="mb-2 row" [ngClass]="locked?'disabled':''">
            <div class="px-sm-2 col-md-12 col-lg-6">
                <div>
                    <ng-container *ngTemplateOutlet="locationTitle; context: {index: 1}" ></ng-container>
                    <div *ngIf="!isEditing" class="d-inline-block ref-measurements-value-cell" style="min-width:2em;"
                        role="button" (click)="onValueClicked()">
                        {{_scoutPoint.refData.location1Distance}}
                    </div>
                    <input *ngIf="isEditing" type="text" name="location1Distance" #location1Distance="ngModel" number [min]="0" size="3"
                        [(ngModel)]="_scoutPoint.refData.location1Distance" 
                        [ngClass]="{ 'invalid-input': location1Distance.invalid && (location1Distance.dirty || location1Distance.touched)}">
                    <div class="d-inline-block ref-measurements-label-cell text-left">meters</div>
                </div>
            </div>

            <div class="px-sm-2 col-md-12 col-lg-6">
                <div>
                    <ng-container *ngTemplateOutlet="locationTitle; context: {index: 2}" ></ng-container>
                    <div *ngIf="!isEditing" class="d-inline-block ref-measurements-value-cell" style="min-width:2em;"
                        role="button" (click)="onValueClicked()">
                        {{_scoutPoint.refData.location2Distance}}
                    </div>
                    <input *ngIf="isEditing" type="text" name="location2Distance" #location2Distance="ngModel" number [min]="0" size="3"
                        [(ngModel)]="_scoutPoint.refData.location2Distance" 
                        [ngClass]="{ 'invalid-input': location2Distance.invalid && (location2Distance.dirty || location2Distance.touched)}">
                    <div class="d-inline-block ref-measurements-label-cell text-left">meters</div>
                </div>
            </div>    
        </div>

        <div *ngIf="isLoadingPhotos" class="busy-overlay-parent p-5">
            <div class="font-weight-bold busy-overlay">
                <i class="fa fa-spinner fa-spin"></i>&nbsp;Searching for photos...
            </div>
        </div>        
        <div [ngStyle]="{ 'display': isLoadingPhotos?'none':'initial'}">
            
        <ng-container *ngIf="!hidePhotos">
        <div class="row"> 
            <ng-container *ngFor="let photo of photoDocs; index as index;">
                <div *ngIf="photo.group=='measurement'" class="px-sm-2 col-md-12 col-lg-6" id="measurement-photos-{{index}}">
                <app-scout-point-photo-editor
                    [scoutTaskDoc]="scoutTaskDoc" 
                    [scoutPathId]="scoutPath?.id" 
                    [scoutPoint]="_scoutPoint"
                    [scoutPhoto]="photo"
                    [isEditing]="isEditing"
                    [locked]="locked"
                    [groupName]="'measurement'"
                    [editableDescription]="true"
                    [photoClickHandler]="onPhotoClick"
                    (editChange)="editChange.emit($event)"
                    (deleted)="onPhotoDocDeleted($event)"
                    (saved)="onPhotoSaved($event)"
                    (orderChanged)="onPhotoOrderChanged($event)"
                    [selectedPhoto]="selectedPhoto"
                    (selectedPhoto)="selectedPhoto">
                </app-scout-point-photo-editor>
            </div>
            </ng-container>
        </div>

        <div id="wide-angle-photos" class="ref-measurements-titlebar w-100" [ngStyle]="{'background-color': _scoutPoint.color}">
            <div class="d-flex flex-row justify-content-between">
                <div>
                    <button class="btn btn-scroll-to" (click)="scrollTo('measurement-photos')"><i class="fa fa-fast-backward" title="top"></i></button>
                </div>
                <div class="flex-grow-1">Wide-angle Views</div>
                <div>
                    <button class="btn btn-scroll-to" (click)="scrollTo('path-view-photos')"><i class="fa fa-step-forward"></i></button>
                    <button class="btn btn-scroll-to" (click)="scrollTo('additional-photos')"><i class="fa fa-fast-forward" title="Additional Photos"></i></button>                    
                </div>
            </div>             
        </div>
    
        <div class="row"> 
            <ng-container *ngFor="let photo of photoDocs; index as index;">
                <div *ngIf="photo.group=='wide-angle'" class="px-sm-2 col-md-12 col-lg-6" id="wide-angle-photos-{{index}}">
                <app-scout-point-photo-editor
                    [scoutTaskDoc]="scoutTaskDoc" 
                    [scoutPathId]="scoutPath?.id" 
                    [scoutPoint]="_scoutPoint"
                    [scoutPhoto]="photo"
                    [isEditing]="isEditing"
                    [locked]="locked"
                    [groupName]="'wide-angle'"
                    [editableDescription]="true"
                    [photoClickHandler]="onPhotoClick"
                    (editChange)="editChange.emit($event)"
                    (deleted)="onPhotoDocDeleted($event)"
                    (saved)="onPhotoSaved($event)"
                    (orderChanged)="onPhotoOrderChanged($event)"
                    [selectedPhoto]="selectedPhoto"
                    (selectedPhoto)="selectedPhoto">
                </app-scout-point-photo-editor>
            </div>
            </ng-container>
        </div>

        <div id="path-view-photos" class="ref-measurements-titlebar w-100" [ngStyle]="{'background-color': _scoutPoint.color}">
            <div class="d-flex flex-row justify-content-between">
                <div>
                    <button class="btn btn-scroll-to" (click)="scrollTo('measurement-photos')"><i class="fa fa-fast-backward" title="top"></i></button>
                    <button class="btn btn-scroll-to" (click)="scrollTo('wide-angle-photos')"><i class="fa fa-step-backward"></i></button>
                </div>
                <div class="flex-grow-1">Path Views</div>
                <div>
                    <button class="btn btn-scroll-to" (click)="scrollTo('additional-photos')"><i class="fa fa-fast-forward" title="Additional Photos"></i></button>                    
                </div>
            </div> 
        </div>

        <div class="row"> 
            <ng-container *ngFor="let photo of photoDocs; index as index;">
                <div *ngIf="photo.group=='point-to-point'" class="px-sm-2 col-md-12 col-lg-6" id="path-view-photos-{{index}}">
                <app-scout-point-photo-editor
                    [scoutTaskDoc]="scoutTaskDoc" 
                    [scoutPathId]="scoutPath?.id" 
                    [scoutPoint]="_scoutPoint"
                    [scoutPhoto]="photo"
                    [isEditing]="isEditing"
                    [locked]="locked"
                    [groupName]="'point-to-point'"
                    [editableTitle]="true"
                    [editableDescription]="true"
                    [photoClickHandler]="onPhotoClick"
                    (editChange)="editChange.emit($event)"
                    (deleted)="onPhotoDocDeleted($event)"
                    (saved)="onPhotoSaved($event)"
                    (orderChanged)="onPhotoOrderChanged($event)"
                    (selectedPhoto)="selectedPhoto"
                    [selectedPhoto]="selectedPhoto">
                </app-scout-point-photo-editor>
            </div>
            </ng-container>
            <div class="px-4 pb-4" *ngIf="isEditing">
                <button class="btn btn-secondary btn-sm" (click)="onNewPhoto('point-to-point')"><i class="fa fa-plus"></i> Add Path Photo</button>
            </div>
        </div>

        <div id="additional-photos" class="ref-measurements-titlebar w-100" [ngStyle]="{'background-color': _scoutPoint.color}">
           <div class="d-flex flex-row justify-content-between">
            <div>
                <button class="btn btn-scroll-to" (click)="scrollTo('measurement-photos')"><i class="fa fa-fast-backward" title="top"></i></button>
                <button class="btn btn-scroll-to" (click)="scrollTo('path-view-photos')"><i class="fa fa-step-backward"></i></button>
            </div>
            <div class="flex-grow-1">Additional Photos</div>
            <div></div>
           </div> 
        </div>
        
        <div class="row"> 
            <ng-container *ngFor="let photo of photoDocs; index as index;">
                <div *ngIf="!photo.group||photo.group=='additional'" class="px-sm-2 col-md-12 col-lg-6" id="additional-photos-{{index}}">
                <app-scout-point-photo-editor
                    [scoutTaskDoc]="scoutTaskDoc" 
                    [scoutPathId]="scoutPath?.id" 
                    [scoutPoint]="_scoutPoint"
                    [scoutPhoto]="photo"
                    [isEditing]="isEditing"
                    [locked]="locked"
                    [editableTitle]="true"
                    [editableDescription]="true"
                    [groupName]="'additional'"
                    [photoClickHandler]="onPhotoClick"
                    (editChange)="editChange.emit($event)"
                    (deleted)="onPhotoDocDeleted($event)"
                    (saved)="onPhotoSaved($event)"
                    (orderChanged)="onPhotoOrderChanged($event)"
                    (selectedPhoto)="selectedPhoto">
                </app-scout-point-photo-editor>
            </div>
            </ng-container>
            <div class="px-4" *ngIf="isEditing">
                <button class="btn btn-secondary btn-sm" (click)="onNewPhoto('additional')"><i class="fa fa-plus"></i> Add Additional Photo</button>
            </div>
        </div>
        
        </ng-container>
        </div>

        <ng-template #locationTitle let-index="index" let-location="location">
            <div class="d-inline-block pr-1">
            <div *ngIf="_scoutPoint.type=='HA'; else notHaScoutPoint" class="pl-0 ref-measurements-label-cell">
                Distance to reference location {{index}}:
            </div>
            <ng-template #notHaScoutPoint>
            <div class="pl-0 ref-measurements-label-cell">
                Distance to wall reference location {{index}}:
            </div>
            </ng-template>
            </div>
        </ng-template>

    </div>
</form>